import React, { Component } from 'react'
import { Form, Input } from 'antd';
import { Dropdown } from '../../../../../components/common/dropdown';
import { CONTRACT_TYPE } from '../../../../../common/utils/static-data';

export class BranchManager extends Component {
  state = {
    branchs: [],
  }

  onSelect = data => {
    const { onChangeForm } = this.props;
    onChangeForm('branch_code',data.code );
  }
  render() {
    const { branchs } = this.state;
    const { unlimitEdit, contract_type } = this.props;
    return <>
      <div style={{ marginTop: 0}} className="title-contract title-special">
        1. Chi nhánh quản lý xe*
        </div>
      <Form.Item 
        name={'branch_code'}
        wrapperCol={24} rules={[
        {
          required: true,
          message: `Vui lòng chọn chi nhánh quản lý xe!`,
        }
      ]}>
        <Dropdown 
          disabled={!unlimitEdit}
          select={this.onSelect} 
          className="dropdown-full" 
          title="Chọn chi nhánh" 
          menu={branchs} />
      </Form.Item>
      <Form.Item
        name={'vehicle_working_area'}
        label={'*Khu vực xe hoạt động::'}
        wrapperCol={15}
        rules={[
          {
            required: true,
            message: `Vui lòng nhập Khu vực xe hoạt động!`,
          }
        ]}>
        <Input disabled={!unlimitEdit} placeholder="Khu vực xe hoạt động" />
      </Form.Item>
    </>
  }
}
